<template>
  <div>
    <LoadingAnimation v-if="loading" />
    <!-- <ChartComponent v-else /> -->
    <ChartComponenttwo v-else />
  </div>
</template>

<script>
import LoadingAnimation from '@/components/loding.vue'; // 你的 loading 动画组件
import ChartComponent from '@/components/ChartComponent.vue'; // 你的仓库可视化
import ChartComponenttwo from '@/components/ChartComponenttwo.vue'; // 你的仓库可视化

export default {
  data() {
    return {
      loading: true, // 初始显示 loading 动画
      // 其他数据和状态...
    };
  },
  mounted() {
    // 模拟数据加载完成后切换显示
    setTimeout(() => {
      this.loading = false;
    }, 3000); // 假设数据加载耗时 2 秒
  },
  components: {
    LoadingAnimation,
    ChartComponent,
    ChartComponenttwo
  },
};
</script>
